<template>
  <q-btn
    round
    class="san-button san-button--icon"
    :class="classes"
    :style="style"
  >
    <template
      v-for="(slot, slotName) in $slots"
      #[slotName]="scope"
      :key="slotName"
    >
      <slot
        :name="slotName"
        v-bind="scope || {}"
      />
    </template>
  </q-btn>
</template>

<script setup>
import { computed, useAttrs } from 'vue'
import { useButton } from '@/composables'

defineOptions({ name: 'SanButtonIcon' })
const props = defineProps({
  fullwidth: { type: Boolean, default: false }
})

const $attrs = useAttrs()
const { style } = useButton({ isIcon: true })

const classes = computed(() => {
  const classes = [`size-${$attrs.size ?? 'md'}`]
  return classes
})
</script>
